import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

const Title = ({ iconPath, altText, title = '', subtitle = '' }) => {
    const { t } = useTranslation();
    return (
        <div>
            <div className={styles.title}>
                {!!title ? <h1 className={styles.mainTitle}>{title}</h1> : <img src={iconPath} alt={altText} />}
            </div>
            {!!subtitle ? (
                <h2 className={classNames(styles.descr, styles.longSubtitle)}>{subtitle}</h2>
            ) : (
                <h2 className={styles.descr}>{t('pages.landing.title')}</h2>
            )}
        </div>
    );
};

export default Title;
